
const NAMESPACE = "http://genmagic.org/"
const ADMIN_ROLE = "admin"
const ROLES = "roles"
const NAMESPACE_ROLES = NAMESPACE + ROLES

export default function getUserIsAdmin(user) {
    const roles = user && user[NAMESPACE_ROLES] && user[NAMESPACE_ROLES]
    return roles && roles.includes(ADMIN_ROLE)
}